import { showToast } from '$lib/helpers/toastrHelper';
import { extractErrorMessage } from '$lib/utils/error/errorUtils';
import { fetchWithAuth } from '$lib/utils/http/httpUtil';

function createCcrStatementStore() {
  const baseUrl = '/api/ccr';

  return {
    async deleteAllStatements(clientId: number): Promise<void> {
      const response = await fetchWithAuth(`${baseUrl}/statements/delete`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ clientId }),
      });

      if (!response.ok) {
        const errorMessage = await extractErrorMessage(response, 'Failed to delete statements');
        showToast({
          title: 'Error',
          message: errorMessage,
          type: 'error',
        });
        throw new Error(errorMessage);
      }
    },

    async deleteStatementsBefore(clientId: number, dateTo: string): Promise<void> {
      const response = await fetchWithAuth(`${baseUrl}/statements/delete`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ clientId, dateTo: dateTo }),
      });

      if (!response.ok) {
        const errorMessage = await extractErrorMessage(response, 'Failed to delete statements');
        showToast({
          title: 'Error',
          message: errorMessage,
          type: 'error',
        });
        throw new Error(errorMessage);
      }
    },
  };
}

export const ccrStatementStore = createCcrStatementStore();
